import React, { useContext } from "react";
import PropTypes from "prop-types";

import { Title, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import DataTable from "../../../../../components/DataTable";

import {
  ROUTE_PRODUCT_DETAILS_COLUMNS,
  ROUTE_PRODUCT_BILLING_COLUMNS
} from "./columns";

import { ALL_ROUTE_PRODUCTS_QUERY } from "../../../../../graphql/Routes/RouteProducts.graphql";

import {
  AddRouteProductForm,
  EditRouteProductForm
} from "../../../../../components/Routes";

import { ModalContext } from "../../../../../components/ModalProvider";

function RouteProducts({ route, isDispatching = false }) {
  const { setModalOpen } = useContext(ModalContext);

  const handleAdd = () => {
    setModalOpen(
      true,
      <AddRouteProductForm
        RouteRecIdRef={route.RecId}
        isAddingAsDispatcher={isDispatching}
        setModalOpen={() => setModalOpen(false, "")}
      />
    );
  };

  return (
    <div className="subpage">
      <div className="page-head">
        <div className="page-head-start">
          <Title subtitle size={5}>
            Route Products
          </Title>
        </div>
        <div className="page-head-end">
          <Button color="success" size="small" onClick={handleAdd}>
            <Icon>
              <FontAwesomeIcon icon="plus" />
            </Icon>
            <span>Add Product</span>
          </Button>
        </div>
      </div>
      <DataTable
        columns={
          isDispatching
            ? ROUTE_PRODUCT_DETAILS_COLUMNS
            : ROUTE_PRODUCT_BILLING_COLUMNS
        }
        dataQuery={ALL_ROUTE_PRODUCTS_QUERY}
        name="RouteProduct"
        where={
          isDispatching
            ? {
                RouteRecIdRef: parseInt(route.RecId),
                ProductCatgRecIdRef: 306
              }
            : { RouteRecIdRef: parseInt(route.RecId) }
        }
        onRowClick={routeProduct =>
          setModalOpen(
            true,
            <EditRouteProductForm
              isAddingAsDispatcher={isDispatching}
              routeProduct={routeProduct}
              setModalOpen={setModalOpen}
            />
          )
        }
      />
    </div>
  );
}

RouteProducts.propTypes = {
  route: PropTypes.object,
  isDispatching: PropTypes.bool
};

export default RouteProducts;
